import React from "react";
import useFetch from "../../hooks/useFetch";
import "./FeaturedDesc.scss";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const FeaturedDesc = ({ isNew }) => {
    const locale = useSelector((state) => state.language?.locale || "pl");
    const { data, loading } = useFetch(`/featured-descs?populate=*&locale=${locale}`);

    if (loading) return <div><FormattedMessage id="loading" /></div>;

    const featuredDesc = data?.[0]?.descriptionFeatured;
    const newDesc = data?.[0]?.descriptionNew;

    return (
        <div className="featuredDesc">
            {isNew ? (
                <Typography component="span">{newDesc || <FormattedMessage id="featured_desc_new" />}</Typography>
            ) : (
                <Typography component="span">{featuredDesc || <FormattedMessage id="featured_desc_bestsellers" />}</Typography>
            )}
        </div>
    );

};

export default FeaturedDesc;
